"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FileUpload = void 0;
var React = __importStar(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var Common_1 = require("../Common");
var Icon = (0, styled_components_1.default)(Common_1.Icon)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\tmargin-right: 10px;\n"], ["\n\tmargin-right: 10px;\n"])));
Icon.displayName = 'Icon';
var InputFile = styled_components_1.default.input.attrs({
    type: 'file',
    className: 'tws-input-file-upload',
})(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n\tdisplay: none;\n"], ["\n\tdisplay: none;\n"])));
InputFile.displayName = 'InputFile';
var FileNameDisplayWrapper = styled_components_1.default.div.attrs({
    className: 'tws-filename-display-wrapper',
})(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n\tpadding-left: 0;\n\tword-break: break-all;\n\tmax-width: ", ";\n\tfont-size: 12px;\n"], ["\n\tpadding-left: 0;\n\tword-break: break-all;\n\tmax-width: ", ";\n\tfont-size: 12px;\n"])), function (props) { return props.fileNameLabelWidth; });
FileNameDisplayWrapper.displayName = 'FileNameDisplayWrapper';
var FileUpload = /** @class */ (function (_super) {
    __extends(FileUpload, _super);
    function FileUpload(props) {
        var _this = _super.call(this, props) || this;
        _this.onChangeHandler = function (e) {
            if (e.target.value && e.target.files) {
                _this.fileChange(e.target.files);
                if (_this.props.getValue) {
                    _this.props.getValue(e.target.files);
                }
            }
            e.target.value = '';
        };
        _this.state = {
            files: undefined,
        };
        _this.fileChange = _this.fileChange.bind(_this);
        _this.openFileUpload = _this.openFileUpload.bind(_this);
        _this.onChangeHandler = _this.onChangeHandler.bind(_this);
        _this.inputFileUpload = React.createRef();
        return _this;
    }
    FileUpload.prototype.UNSAFE_componentWillReceiveProps = function (nextProps) {
        this.setState({ files: nextProps.files });
    };
    FileUpload.prototype.render = function () {
        var _this = this;
        return (React.createElement("div", null,
            React.createElement(Common_1.Button, { noresize: 'true', color: this.props.btnColor ? this.props.btnColor : 'primary', onClick: this.openFileUpload, size: this.props.btnSize, disabled: this.props.disabled, className: 'tws-button-file-upload' },
                this.props.iconName ? React.createElement(Icon, { name: this.props.iconName }) : null,
                this.props.btnTitle),
            React.createElement(InputFile, { ref: function (fp) { return (_this.inputFileUpload = fp); }, multiple: this.props.multiple, onChange: this.onChangeHandler }),
            React.createElement(FileNameDisplayWrapper, __assign({}, this.props),
                this.state.files || this.props.textFieldTitle ? React.createElement("i", null, "File: ") : null,
                this.state.files && typeof this.state.files === typeof []
                    ? this.state.files.map(function (fileName, i) { return (React.createElement("div", { className: 'tws-filename-' + i, key: i }, fileName)); })
                    : this.state.files
                        ? this.state.files
                        : this.props.textFieldTitle)));
    };
    FileUpload.prototype.openFileUpload = function () {
        var fileUpload = this.inputFileUpload;
        if (fileUpload) {
            fileUpload.click();
        }
    };
    FileUpload.prototype.fileChange = function (files) {
        if (files.length > 0) {
            if (files.length > 1) {
                var filesNames = [];
                for (var i = 0; i < files.length; i++) {
                    filesNames.push(files[i].name);
                }
                this.setState({ files: filesNames });
            }
            else {
                this.setState({ files: files[0].name });
            }
        }
        else {
            this.setState({ files: undefined });
        }
    };
    return FileUpload;
}(React.Component));
exports.FileUpload = FileUpload;
var templateObject_1, templateObject_2, templateObject_3;
